import React from 'react';
import PropTypes from 'prop-types';

import TextSmall from '../TextSmall';

import {
  OverBoxEmployee,
  OverBoxEmployeeEmpty,
  BoxSkill,
  ItemSkill,
  TitleSkill,
  BarSkill,
  BarProgress,
  TextBarSkill,
  StyleEditIcon
} from './style';

import { Pencil } from '../../../../assets/images/index';

/**
 * Get level of skill and return a suitable number value
 * @param {string} level - Level of skill
 */

const getNumberFromLevel = level => {
  switch (level) {
    case 'HIGH':
      return 10;
    case 'MEDIUM':
      return 6;
    case 'LOW':
      return 4;
    default:
      return 4;
  }
};

const Resume = (dataSkill, limit) =>
  dataSkill &&
  dataSkill.slice(0, limit).map(item => (
    <ItemSkill key={item.name}>
      <TitleSkill>{item.name}</TitleSkill>
      <BarSkill>
        <BarProgress comp={getNumberFromLevel(item.skillLevel)} />
        <TextBarSkill>
          {item.skillLevel === 'HIGH' && 'Alto'}
          {item.skillLevel === 'MEDIUM' && 'Medio'}
          {item.skillLevel === 'LOW' && 'Bajo'}
        </TextBarSkill>
      </BarSkill>
    </ItemSkill>
  ));

const SkillUser = ({
  className,
  dataSkill,
  limit,
  onEditMode,
  clickEditIcon
}) =>
  dataSkill && dataSkill.length !== 0 ? (
    <OverBoxEmployee
      className={className}
      title="Hobbies"
      more={dataSkill && dataSkill.length > limit}
      moreInfo={Resume(dataSkill, dataSkill ? dataSkill.length : 0)}
    >
      <BoxSkill>
        {onEditMode && (
          <StyleEditIcon
            svg={Pencil}
            size="m"
            color="dark"
            onClick={clickEditIcon}
            hover
          />
        )}
        {Resume(dataSkill, limit)}
      </BoxSkill>
    </OverBoxEmployee>
  ) : (
    <OverBoxEmployeeEmpty className={className} title="Hobbies">
      <BoxSkill>
        {onEditMode && (
          <StyleEditIcon
            svg={Pencil}
            size="m"
            color="dark"
            onClick={clickEditIcon}
            hover
          />
        )}
        <TextSmall>Parece que aún no hay hobbies para mostrar.</TextSmall>
      </BoxSkill>
    </OverBoxEmployeeEmpty>
  );

SkillUser.propTypes = {
  className: PropTypes.string,
  dataSkill: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      skillLevel: PropTypes.string
    })
  ),
  limit: PropTypes.number,
  onEditMode: PropTypes.bool,
  clickEditIcon: PropTypes.func
};

export default SkillUser;
